<template>
  <component
    :is="dialog ? DialogScrollLock : 'div'"
    width="800"
    :value="value"
    @input="v => $emit('input', v)"
  >

    <error-dialog :status="loadStatus" />

    <v-card dark>
      <v-responsive :aspect-ratio="16/9">
        <div
          v-if="loadStatus.pending || !project"
          class="absolute-fill d-flex justify-center align-center"
          style="z-index: 1;"
        >
          <v-progress-circular indeterminate color="white" />
        </div>
        <div
          v-else-if="project.private && (mode == 'sign') && (globalUserId != owner)"
          class="absolute-fill d-flex justify-center align-center"
          style="z-index: 1;"
        >
          <div class="white--text">This video is private</div>
        </div>
        <video-player v-else-if="src || error" class="absolute-fill" allow-fullscreen :src="src" :error="error" @play-video="$emit('play-video')">
          <v-card-title class="pa-3 d-flex align-center">
            <v-spacer />
            <download-group-video-btn class="mr-2" :project="project" />
            <v-btn v-if="dialog" icon @click="$emit('input', false)">
              <v-icon v-html="mdiClose" />
            </v-btn>
          </v-card-title>
        </video-player>
        <video-preview-player v-else-if="build" :video="build" @slow-playback="$emit('slow-playback')" @play-video="$emit('play-video')">
          <v-card-title class="py-3 d-flex align-center">
            <v-spacer />
            <download-group-video-btn
              class="mr-2"
              :project="project"
              @update-notify="x => project.render_notify = x"
              @reload="load"
            />
            <v-btn v-if="dialog" icon @click="$emit('input', false)">
              <v-icon v-html="mdiClose" />
            </v-btn>
          </v-card-title>
        </video-preview-player>
      </v-responsive>
    </v-card>
  </component>
</template>

<script>
import DialogScrollLock from '@/components/DialogScrollLock.vue';
import DownloadGroupVideoBtn from '@/components/DownloadGroupVideoBtn.vue';
import ErrorDialog from '@/components/ErrorDialog.vue';
import VideoPlayer from '@/components/VideoPlayer.vue';
import VideoPreviewPlayer from '@/components/VideoPreviewPlayer.vue';
import { publicGroupVideoTemplate } from '@/mixins/public-group-video-template.js';
import { buildTemplateModule } from '@/utils/group-video-template.js';
import { mdiClose, mdiDownload } from '@mdi/js';

export default {
  name: 'group-video-playback',

  components: {
    DownloadGroupVideoBtn,
    ErrorDialog,
    VideoPlayer,
    VideoPreviewPlayer
  },

  mixins: [ publicGroupVideoTemplate ],

  // mode: sign | open
  props: { projectId: String, mode: String, value: Boolean, dialog: Boolean },

  data() {
    return {
      src: null,
      project: null,
      build: null,
      error: null,
      loadStatus: this.$track('load')
    };
  },

  created() {
    Object.assign(this, { DialogScrollLock, mdiClose, mdiDownload });
  },

  methods: {
    async load() {
      if (!this.projectId) {
        this.src = null;
        this.project = null;
        this.build = null;
        this.error = null;
        return;
      }
      const p = await this.$call('get-group-video-project', { project_id: this.projectId, for_playback: true });
      if (p.render && !p.render.failed && p.render.finished_at && p.render.finished_at > p.last_visible_update_at) {
        this.src = p.render.url;
      } else {
        this.src = null;

        if (!p.render_notify)
          // Make sure this property is reactive
          p.render_notify = {};

        const template = await this.getPublicGroupVideoTemplate(p.template_id);
        const code = template.use_code ? template.code : null;
        const graph = template.use_graph ? JSON.parse(template.graph) : null;
        const Builder = buildTemplateModule(code, template.assets);
        const builder = new Builder(p, graph, template.assets);
        try {
          this.build = await builder.build();
          this.error = null;
        } catch (e) {
          console.error(e);
          this.build = null;
          this.error = 'This video has not been rendered';
        }
      }
      this.project = p;
    }
  },

  watch: {
    projectId: {
      immediate: true,
      handler() {
        this.load();
      }
    }
  }
}
</script>
